import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Socket } from 'ngx-socket-io';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})

export class WidgetService {
  baseUrl = `${this.env.URL_API}/widgets`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
    private socket: Socket,
    private env: EnvService
  ) {
  }

  getCasosAnalizados(id): Observable<any> {

    const url = `${this.baseUrl}/casos_analizados/${id}`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((resp: Response) => {
        return resp || {};
      }),
      catchError(this.handleError)
    );
  }

  getMisCanales(id): Observable<any> {
    const url = `${this.baseUrl}/canales/${id}`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((resp: Response) => {
        return resp || [];
      }),
      catchError(this.handleError)
    );
  }

  getMisMontos(id): Observable<any> {
    const url = `${this.baseUrl}/montos/${id}`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((resp: Response) => {
        return resp || [];
      }),
      catchError(this.handleError)
    );
  }

  getCasosAnalistas(): Observable<any> {
    const url = `${this.baseUrl}/casos_analistas`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((resp: Response) => {
        return resp || [];
      }),
      catchError(this.handleError)
    );
  }

  getCanalesAnalistas(): Observable<any> {
    const url = `${this.baseUrl}/canales_analistas`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((resp: Response) => {
        return resp || [];
      }),
      catchError(this.handleError)
    );
  }
  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }


}
